import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.753 4.842a1 1 0 0 1-.094 1.41L6.66 8h9.089a5.25 5.25 0 1 1 0 10.5H14a1 1 0 1 1 0-2h1.75a3.25 3.25 0 0 0 0-6.5H6.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 .048-1.46l4-3.5a1 1 0 0 1 1.412.095",
      clipRule: "evenodd"
    }
  )
);
var SvgUndoOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var UndoOutlined_default = SvgUndoOutlined;

export { UndoOutlined_default as default };
